import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  stateGrid: {
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(20%, 1fr))',
    },
    [theme.breakpoints.down('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(40%, 1fr))',
      gridGap: theme.spacing(3),
    },
    [theme.breakpoints.down(530)]: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(100%, 1fr))',
    },
  },
}));

export const useStateCardStyles = makeStyles((theme) => ({
  stateCard: {
    textAlign: 'center',
    cursor: 'pointer',
    transition: '300ms ease',
    borderRadius: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(3),
    },
    [theme.breakpoints.down(530)]: {
      marginRight: 0,
    },
    '&:hover': {
      transform: 'scale(1.02)',
      boxShadow: '0px 4px 8px rgb(0 0 0 / 8%)',
    },
  },
  stateIcon: {
    overflow: 'hidden',
    '& > svg': {
      height: '108px',
      width: '108px',
      fill: colors.gray.l20,
      color: colors.gray.l20,
      viewBox: 'unset',
    },
  },
  title: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '2rem',
    letterSpacing: '0.25px',
  },
}));
